import { GeneralSetting, User } from '@apis/index'
import { Shereabook } from '@assets/images'
import Button from '@components/button'
import Fields from '@components/fields'
import Image from '@components/image'
import Typography from '@components/typography'
import { Helper } from '@utils/index'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthFooter from '../component/authFooter'
import GoBack from '@components/back'
import { requestPermission } from '@utils/pushNotification'
import { AuthSchema } from '@validations/index'
import {
  AuthCard,
  AuthContainer,
  AuthHeader,
  AuthWrapper,
  BottomSection,
  ForgotPasswordLink,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
  RememberForgotContainer,
} from '../style'
import { useSelector } from 'react-redux'
import HelmetSeo from '@components/HelmetSeo'

const AuthPage = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const location = useLocation()
  const [fcmToken, setFcmToken] = useState(null)
  const fetchFCMToken = async () => {
    try {
      const fcmToken = await requestPermission()
      setFcmToken(fcmToken)
    } catch (error) {
      console.error('Error fetching FCM token:', error)
    }
  }

  useEffect(() => {
    fetchFCMToken()
  }, [])
  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload: any = {
      username: values.username,
      password: values.password,
    }
    if (fcmToken) {
      payload.deviceToken = fcmToken
    }
    await User.login(payload)
      .then((resp) => {
        if (resp?.role === 'user') {
          Helper.saveUser(resp)
          navigate('/books')
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const { data: loginSeo } = useSelector((state: any) => state.loginSeo)
  const fetchHomeSeo = async (state: string, key: string) => {
    await GeneralSetting.getByKey(state, key).catch(() => {})
  }

  const [initialValues, setInitialValues] = useState({
    metaTitle: '',
    metaDescription: '',
    metaKeyword: '',
  })
  useEffect(() => {
    if (!!loginSeo?.id) {
      const loginSeoValue = !!loginSeo?.value
        ? JSON.parse(loginSeo?.value)
        : null
      setInitialValues({
        metaTitle: loginSeoValue?.metaTitle,
        metaDescription: loginSeoValue?.metaDescription,
        metaKeyword: loginSeoValue?.metaKeyword,
      })
    }
  }, [loginSeo?.id])
  useEffect(() => {
    if (!loginSeo?.id) {
      fetchHomeSeo('loginSeo', 'loginSeo')
    }
  }, [])

  return (
    <>
      <HelmetSeo
        title={initialValues?.metaTitle}
        description={initialValues?.metaDescription}
        keywords={initialValues?.metaKeyword}
      />
      <AuthWrapper>
        <AuthCard>
          <AuthContainer>
            <GoBack visibleForDesktop={false} />

            <AuthHeader>
              <Typography variant="h3">Get Started with</Typography>
              <Image src={Shereabook} customStyle={'height: 50px'} />
            </AuthHeader>

            <Formik
              initialValues={{
                username: location.state?.username || '',
                password: location.state?.password || '',
              }}
              validationSchema={AuthSchema.loginValidationSchema}
              enableReinitialize
              onSubmit={submitHandler}
            >
              {({ handleSubmit, setFieldValue }) => {
                return (
                  <FormWrapper>
                    <Form onSubmit={handleSubmit}>
                      <FormContainer>
                        <FormInputsContainer>
                          <Fields.PhoneInput
                            name="username"
                            label="Mobile Number"
                            styleInput="border:1px solid #000;"
                            placeholder="Enter your mobile number"
                            styleWrapper=""
                            onChangeCode={(codes) => {
                              setFieldValue('countryCode', codes.callingCode)
                            }}
                          />

                          <Fields.Password
                            name="password"
                            label="Password"
                            placeholder="Enter your password"
                          />

                          <RememberForgotContainer>
                            <Fields.Checkbox
                              name="rememberMe"
                              label="Remember Me"
                            />
                            <ForgotPasswordLink
                              type="button"
                              onClick={() =>
                                navigate('/phone-input-reset-password')
                              }
                            >
                              Forgot Password?
                            </ForgotPasswordLink>
                          </RememberForgotContainer>
                        </FormInputsContainer>

                        <BottomSection>
                          <AuthFooter
                            content="Don't have an account?"
                            tag="Register Now"
                            onClick={() => navigate('/phone-input')}
                          />
                          <Button
                            title="Submit"
                            styleButton="width:100%;"
                            height={45}
                            type="submit"
                            loading={loading}
                          />
                        </BottomSection>
                      </FormContainer>
                    </Form>
                  </FormWrapper>
                )
              }}
            </Formik>
          </AuthContainer>
        </AuthCard>
      </AuthWrapper>
    </>
  )
}

export default AuthPage
